var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-play"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "play",
    clipPath: "url(#clip-play)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28999",
    "data-name": "Path 28999",
    d: "M19.274,8.139,8.17.537A2.711,2.711,0,0,0,6.711,0C5.88,0,5.367.666,5.367,1.782v16.43c0,1.114.513,1.779,1.341,1.779a2.688,2.688,0,0,0,1.453-.538l11.109-7.6a2.279,2.279,0,0,0,1.11-1.856A2.271,2.271,0,0,0,19.274,8.139Z",
    transform: "translate(-0.366 2.005)",
    fill: "#33cdd1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.028d210e3a76120578fbbf96e81e4837.svg";
export { ForwardRef as ReactComponent };